import React from "react";
import Journey from "./Journey";
import Map from "./Map";
import { ReactComponent as Logo } from "./logo.svg";
import "./app.css";
import CategoryJourney from "./CategoryJourney/CategoryJourney";

export default function App() {
  const [continent, setContinent] = React.useState(null);
  const [category, setCategory] = React.useState(null);
  const render = () => {
    if (continent !== null && continent !== undefined) {
      return <Journey continent={continent} setContinent={setContinent} />;
    } else if (
      category !== null &&
      category !== undefined &&
      typeof category === "string"
    ) {
      return <CategoryJourney category={category} setCategory={setCategory} />;
    } else {
      return <Map setContinent={setContinent} setCategory={setCategory} />;
    }
  };
  return (
    <div className='app'>
      <div className='logo-container'>
        <a href={`./${window.location.search}`}>
          <Logo className='logo' />
        </a>
      </div>
      {render()}
    </div>
  );
}
